/* eslint-disable no-lone-blocks */
/**
 * @file paddle hack partner
 * @author wanzhongyun
 */

import React from 'react';
import { RootObject } from '../../type';

import './style.less';


const HackPartner = (props: RootObject["paddleHackathonPartner"]) => {

    const {
        titleImageUrl,
        content,
        subTitle
    } = props;

    return (
        <div className='paddle-hack-partner-f-wrapper'>
            <div className='paddle-hack-partner-f-wrapper-content'>
                <img className='paddle-hack-partner-f-title' src={titleImageUrl} alt='' />
                <div className='paddle-hack-partner-f-sub-title'>{subTitle ?? ''}</div>
                <div className='paddle-hack-partner-f-content'>

                    {(content ? content : []).map((contentImgValue: any,index:number) => {
                        return (
                            <div className='paddle-hack-partner-f-contentImg' key={index}>
                                <div className='paddle-hack-partner-f-contentImg-left'>{contentImgValue.title}</div>
                                <div className='paddle-hack-partner-f-contentImg-right'>
                                    {
                                        (contentImgValue?.partnerList ? contentImgValue.partnerList : []).map((imgContent: any,index:number) => {
                                           
                                            {
                                                if (contentImgValue.partnerList.indexOf(imgContent) > 5) {
                                                  
                                                    
                                                    return (<a className='paddle-hack-partner-f-contentImg-right-a move_a' href={imgContent.detailLink} target='_blank' rel='noreferrer' key={index}>
                                                        <img className='paddle-hack-partner-f-contentImg-rightImg ' src={imgContent.partnerList} alt="" />
                                                    </a>)
                                                } else {
                                                    return (<a className='paddle-hack-partner-f-contentImg-right-a' href={imgContent.detailLink} target='_blank' rel='noreferrer' key={index}>
                                                        <img className='paddle-hack-partner-f-contentImg-rightImg ' src={imgContent.partnerList} alt="" />
                                                    </a>)
                                                }
                                            }
                                        })
                                    }
                                </div>
                            </div>)
                    })}
                </div>
            </div>

        </div>
    );
};

export default HackPartner;